export default __webpack_public_path__ + "static/media/FiraSans-Regular.aa55640c.woff";